import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";

const MENU_PROPS = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
};

const FlowBuilderTagModal = ({ open, onSave, data, onUpdate, close }) => {
  const isMounted = useRef(true);

  const initialState = {
    queue: "",
    user: "",
  };

  const [activeModal, setActiveModal] = useState(false);

  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState();

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          const tag = data.data.tag
          const { data: result } = await api.get("/tags/list");
          setSelectedTag(tag.id);
          setTags(result);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data } = await api.get("/tags/list");
          setSelectedTag("");
          setTags(data);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const fetchTags = async () => {
    try {
      const response = await api.get("/tags/kanban");
      const fetchedTags = response.data.lista || [];

      console.log(fetchedTags);
      setTags(fetchedTags);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedTag) {
      return toast.error("Adicione uma tag");
    }
    if (open === "edit") {
      const tag = tags.find((item) => item.id === selectedTag);

      onUpdate({
        ...data,
        data: {
          tag: tag ? tag : "",
        },
      });
    } else if (open === "create") {
      const tag = tags.find((item) => item.id === selectedTag);

      onSave({
        tag: tag ? tag : "",
      });
    }
    handleClose();
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={open === "create" ? `Adicionar uma tag ao fluxo` : `Editar tag`}
        subtitle="Marca o contato com uma tag quando o fluxo chega neste ponto."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField label="Escolha uma tag">
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              id="flow-tag-select"
              value={selectedTag}
              displayEmpty
              onChange={(e) => {
                setSelectedTag(e.target.value);
              }}
              MenuProps={MENU_PROPS}
              renderValue={() => {
                if (selectedTag === "") {
                  return "Selecione uma tag";
                }
                const tag = tags.find((t) => t.id === selectedTag);
                if (tag === undefined) {
                  return "Nenhuma tag selecionada";
                }
                return tag.name;
              }}
            >
              <MenuItem value="">
                <em>Selecione uma tag</em>
              </MenuItem>
              {tags.length > 0 &&
                tags.map((tag, index) => (
                  <MenuItem dense key={index} value={tag.id}>
                    {tag.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleSaveContact}
        >
          {open === "create" ? `Adicionar` : "Editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderTagModal;
